import { getBaseApiUrl } from './baseUrlRouteBuilder';

const getTeamsRoute = (year: number) => `${getBaseApiUrl()}/Teams?year=${year}`;

export { getTeamsRoute };
